<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="row mb-3">
          <div class="col-lg-12">
            <div class="d-flex">
              <div class="d-flex flex-column">
                <v-btn
                    color="primary darken-3"
                    @click="openFilterDialog"
                    small
                >
                  Ürün Filtrele
                </v-btn>
              </div>
              <div v-if="genericCategoriesArray.length > 0" class="p-4">
                <div>Aktif Filtreler</div>
                <v-chip
                    class="m-2"
                    small
                    v-for="(val, index) in genericCategoriesArray"
                    :key="index"
                    label
                    color="primary"
                >{{ val.name }}
                </v-chip>
              </div>
            </div>
          </div>
          <div class="col-lg-12 d-flex flex-wrap">
            <div class="mx-1">
              <p class="text-center">Görünüm</p>
              <v-btn-toggle solo mandatory dense>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="dataView = 'ResultTableView'; perPage = 10; fetchData();"
                    >
                      <i class="bx bx-menu font-size-16"></i>
                    </v-btn>
                  </template>
                  <span>Tablo Görünüm</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="dataView = 'ResultCardView'; perPage = 12; fetchData();"
                    >
                      <i class="bx bx-card font-size-16"></i>
                    </v-btn>
                  </template>
                  <span>Kart Görünüm</span>
                </v-tooltip>
              </v-btn-toggle>
            </div>
            <div class="mx-1">
              <p class="text-center">Gösterilen Kayıt Sayısı</p>
              <v-btn-toggle v-if="dataView === 'ResultTableView'" mandatory solo dense @change="fetchData" v-model="perPage">
                <v-btn v-for="value in [10, 20, 30, 50, 100]" :key="value" :value="value">
                  {{ value }}
                </v-btn>
              </v-btn-toggle>

              <v-btn-toggle v-else mandatory solo dense @change="fetchData" v-model="perPage">
                <v-btn v-for="value in [12, 24, 36, 48, 96]" :key="value" :value="value">
                  {{ value }}
                </v-btn>
              </v-btn-toggle>
            </div>

            <div class="mx-1 align-self-end">
              <TableColumnSelect
                  class="mb-1"
                  :cols="stockListHeaders"
                  @saveColData="e => editTableColumns(e)"
              >
              </TableColumnSelect>
            </div>

            <div class="ms-auto">
              <v-text-field
                  v-model="searchText"
                  class="mt-5 pt-3"
                  outlined
                  rounded
                  dense
                  placeholder="Arama Yapın..."
                  clearable
                  color="secondary"
                  hide-details
                  append-icon="mdi-magnify"
                  @click:append="fetchData()"
                  @keydown.enter="fetchData(); currentPage = 1"
              ></v-text-field>
            </div>
          </div>
        </div>
        <div>
          <KeepAlive>
            <component :is="dataView" v-bind="dynamicProps"></component>
          </KeepAlive>
        </div>
        <!-- end row -->
        <div class="row">
          <div class="col-lg-12 mb-5">
            <v-pagination
                v-model="currentPage"
                v-if="!stockListLoading"
                class="my-4"
                :length="this.stockListMetaData.totalPages"
                :total-visible="15"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResultCardView from "@/components/product-search/results/ResultsCardViewTest.vue";
import ResultTableView from "@/components/product-search/results/ResultsTableView.vue";
import FilterDialog from "@/components/product-search/dialogs/FilterDialog.vue";

import {mapState, mapActions, mapMutations} from "vuex";
import TableColumnSelect from "@/components/shared/TableColumnSelect.vue";
import ResultsMixin from "@/mixins/ResultsMixin";

export default {
  components: {
    TableColumnSelect,
    ResultCardView,
    ResultTableView,
    FilterDialog
  },
  mixins: [ResultsMixin],

  computed: {
    ...mapState("filterNavigation",["genericCategories","genericCategoriesArray"]),
    ...mapState("stock", ["stockList", "stockListMetaData","stockListHeaders","stockListLoading"]),
    ...mapState("auth", ["user"]),
    ...mapState("cart",["current"]),
    dynamicProps: function() {
      if (this.dataView === "ResultTableView") {
        return { perPage: this.perPage, currentPage: this.currentPage };
      } else return {};
    }
  },
  data() {
    return {
      dataView: "ResultTableView",
      filterDialog: false,
      breadcrumbArray: [
        {
          text: "Products",
          active: true
        }
      ],
    };
  },
  methods: {
    ...mapActions("filterNavigation", ["changeDialog","changePerPage","changeSearchText"]),
    ...mapActions("stock", ["fetchStockList"]),
    ...mapMutations("stock", ["setStockListHeadersPreset"]),

    editTableColumns(cols = []) {
      this.setStockListHeadersPreset(cols);
    },
    async fetchData() {
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        userId: this.user.UserId,
      };
      if (this.current != null && this.current.code != null && this.user.RoleGroupId !== '3') {
        params["currentCode"] = this.current.code;
      }
      await this.fetchStockList({
        params: params,
        body: {
          stock: this.searchText,
          GenericCategories: this.genericCategories,
        },
      });
      this.updateUrl();
    },
    async openFilterDialog() {
      await this.changeDialog(true)
      await this.changePerPage(this.perPage)
      await this.changeSearchText(this.searchText)
    },
  },
};
</script>
